import { error, json } from "@sveltejs/kit";
import jwt from "jsonwebtoken";
import { p as prisma } from "../../../../chunks/prisma.js";
import crypto from "crypto";
function loadMasterKey() {
  const raw = process.env.APP_MASTER_KEY;
  if (!raw) throw new Error("APP_MASTER_KEY missing");
  if (/^[0-9a-fA-F]{64}$/.test(raw)) return Buffer.from(raw, "hex");
  try {
    const b = Buffer.from(raw, "base64");
    if (b.length === 32) return b;
  } catch {
  }
  if (raw.length === 32) return Buffer.from(raw, "utf8");
  throw new Error("APP_MASTER_KEY must be 32 bytes (hex/base64/utf8)");
}
function unwrapDocumentKey(wrappedBase64, masterKey) {
  const data = Buffer.from(wrappedBase64, "base64");
  const iv = data.subarray(0, 12);
  const tag = data.subarray(12, 28);
  const ct = data.subarray(28);
  const decipher = crypto.createDecipheriv("aes-256-gcm", masterKey, iv);
  decipher.setAuthTag(tag);
  return Buffer.concat([decipher.update(ct), decipher.final()]);
}
function getLicenseTTLSeconds() {
  const val = process.env.LICENSE_TTL_SECONDS;
  const n = val ? parseInt(val, 10) : NaN;
  return Number.isFinite(n) && n > 0 && n <= 3600 ? n : 60;
}
async function issueLicense(userId, docId) {
  const entitlement = await prisma.entitlement.findFirst({ where: { userId, documentId: docId } });
  if (!entitlement) throw error(403, "Forbidden");
  if (entitlement.expiresAt && entitlement.expiresAt < /* @__PURE__ */ new Date()) throw error(403, "Entitlement expired");
  const doc = await prisma.document.findUnique({ where: { id: docId } });
  if (!doc) throw error(404, "Document not found");
  const masterKey = loadMasterKey();
  const contentKey = unwrapDocumentKey(doc.wrappedKey, masterKey);
  const ttl = getLicenseTTLSeconds();
  const exp = Math.floor(Date.now() / 1e3) + ttl;
  const JWT_SECRET = process.env.JWT_SECRET;
  if (!JWT_SECRET) throw error(500, "JWT secret not configured");
  const keyB64 = contentKey.toString("base64");
  const pages = { from: 1, to: doc.pageCount };
  const license = jwt.sign({ sub: `doc:${docId}`, docId, key: keyB64, pages }, JWT_SECRET, {
    algorithm: "HS256",
    expiresIn: ttl
  });
  return { license, exp, key: keyB64, pages };
}
const POST = async ({ locals, request }) => {
  const user = locals.user;
  if (!user) throw error(401, "Unauthorized");
  const { docId } = await request.json().catch(() => ({}));
  if (!docId || typeof docId !== "number") throw error(400, "docId required");
  const res = await issueLicense(user.id, docId);
  return json(res);
};
const GET = async ({ locals, url }) => {
  const user = locals.user;
  if (!user) throw error(401, "Unauthorized");
  const docId = Number(url.searchParams.get("docId"));
  if (!docId) throw error(400, "docId required");
  const res = await issueLicense(user.id, docId);
  return json(res);
};
export {
  GET,
  POST
};
